import type { UsageHealthStatus, UsagePoolModel } from '../services/api';

/** MUI Chip colours used by the usage status chips. */
export type ChipColor = 'success' | 'warning' | 'error' | 'default';

export interface StatusMeta {
  label: string;
  color: ChipColor;
  filled: boolean;
}

/**
 * Status-chip presentation shared by the per-org Usage Health page and the
 * per-user usage page. The ONLY per-context difference is the `unknown` label
 * (per-org: "No allocation"; per-user: "No personal cap" — a shared-pool member
 * has no personal cap), so the caller passes its own unknown label.
 */
export function getStatusMeta(unknownLabel: string): Record<UsageHealthStatus, StatusMeta> {
  return {
    healthy: { label: 'Healthy', color: 'success', filled: false },
    low: { label: 'Low', color: 'warning', filled: true },
    critical: { label: 'Critical', color: 'error', filled: false },
    alert: { label: 'Out of runs', color: 'error', filled: true },
    unknown: { label: unknownLabel, color: 'default', filled: false },
  };
}

/** Human labels for the billing pool model, shared across the usage dashboards. */
export const POOL_LABELS: Record<UsagePoolModel, string> = {
  shared: 'Shared pool',
  'per-seat': 'Per-seat',
  unconfigured: 'Unconfigured',
};
